import { type Feature, isFeatureEnabled } from "@nf/constants";

import { useCountry } from "./useCountry";

export const useFeature = (feature: Feature) => {
  const country = useCountry();

  return isFeatureEnabled(feature, country);
};
